import {Component, Input, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExgModalService} from 'exc-controls-v2';
import {EnumerationService} from '../../../../services/enumeration.service';
import {ApplicationService} from '../../../../services/application.service';

@Component({
  selector: 'app-modal-finish-photo-doc',
  templateUrl: './modal-finish-photo-doc.component.html',
  styles: [
  ]
})
export class ModalFinishPhotoDocComponent extends ExcTranslation implements OnInit {
  /*if not Upload its Edit*/
  isUpload = false;
  isOnlyDownload = false;
  get dokTypeIndex(): any {
    return this._dokTypeIndex;
  }

  set dokTypeIndex(index: any) {
    this._stateIndex = index;
    const list = this.enumSvc.getEnumerationList('DokTyp');
    this.chosenDokEnmIdent = list[index].enmIdent;
  }
  @Input() data: any;
  get stateIndex(): number {
    return this._stateIndex;
  }

  set stateIndex(index: number) {
    this._stateIndex = index;
    const list = this.enumSvc.getEnumerationList('PhotoDocumentationStatus');
    this.chosenEnmIdent = list[index].enmIdent;
  }

  pdName = '';
  pdDescription = '';
  private _stateIndex = 0;
  private chosenEnmIdent = 2;
  private chosenDokEnmIdent = 0;
  private _dokTypeIndex: any;
  dokTrackingPortalShare = false;
  constructor(
    private modal: ExgModalService,
    public enumSvc: EnumerationService,
    public appSvc: ApplicationService
  ) {
    super();
  }

  ngOnInit(): void {
    const list = this.enumSvc.getEnumerationList('PhotoDocumentationStatus');
    if (this.data?.isUpload === false) { this.isUpload = this.data.isUpload; }
    else { this.isUpload = true; }
    if (this.data?.editModel?.pdName) { this.pdName = this.data.editModel.pdName; } // nvarChar 256
    if (this.data?.editModel?.pdDescription) { this.pdDescription = this.data.editModel.pdDescription; } // nvarchar 2048
    if (this.data?.editModel?.pdPhotoDocumentationStatus_enmIdent) {
      this.stateIndex = list.map(e => e.enmIdent).indexOf(this.data.editModel.pdPhotoDocumentationStatus_enmIdent);
    }
    if (this.data?.isOnlyDownload) { this.isOnlyDownload = true; }
  }

  delete(): void {
    const editModel = this.data?.editModel;

    if (!editModel?.pdID || !editModel?.pdUPT) {
      return;
    }

    this.modal.action({
      del: true,
      pdID: editModel.pdID,
      pdUPT: editModel.pdUPT
    });
  }

  cancel(): void {
    this.modal.close();
  }

  save(action: 'save' | 'saveAs' = 'save'): void {
    if (this.pdName !== '') {
      this.modal.action({
        action,
        pdName: this.pdName,
        pdDescription: this.pdDescription,
        pdPhotoDocumentationStatus_enmIdent: this.chosenEnmIdent,
        isUpload: this.isUpload
      });
    }
  }
}
